import './form-birthday-reward.scss';

import { BirthdayRewardFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = BirthdayRewardFormSchema;
export function FormBirthdayReward() {
  const { control } = useFormContext<BirthdayRewardFormSchema>();
  return (
    <div id="FormBirthdayReward" className="birthday-reward">
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label="Points"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter points"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamp"
        label="Stamp"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter stamp"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="expiryDays"
        label="Expiry Days"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter expiryDays"
      />
    </div>
  );
}

export default FormBirthdayReward;